import { I18n } from 'aws-amplify'
import { string, object } from 'yup'

export const helpTextSchema = object().shape({
  title: string().required(I18n.get('Title is required')),
  text: string().required(I18n.get('Help text is required'))
})
